module.exports = __webpack_public_path__ + "static/img/certstream-overview.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certstream-overview.png
// module id = Ovzb
// module chunks = 1